import { memo, type ReactNode } from 'react';
import { useFeatureFlag } from 'utils/hooks/posthog/useFeatureFlag';

const FeatureGateBase = ({ flag, children, fallback = null }: { flag: string; children: ReactNode; fallback?: ReactNode }) => {
  const enabled = useFeatureFlag(flag);

  return enabled ? <>{children}</> : <>{fallback}</>;
};

export const FeatureGate = memo(FeatureGateBase) as typeof FeatureGateBase;
